<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .edit-contact {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
    overflow: auto;

    /* CampaignInfoHeading Height */
    &.isTodo {
      height: calc(100% - utils.in_rem(54px));
    }

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: utils.in_rem(32px);
      border-bottom: 1px solid colors.get(interfaceSwGrey_10);
    }

    .body {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(26px);
      padding: utils.in_rem(32px);
      height: 100%;
      overflow: auto;

      .header-with-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: utils.in_rem(16px);

        .input {
          flex: 1 1 utils.in_rem(200px);
          max-width: utils.in_rem(300px);
        }
      }

      &.isTodo {
        padding: utils.in_rem(27px) utils.in_rem(32px);
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: utils.in_rem(28px);
      }

      .divider {
        border: 1px solid colors.get(interfaceSwGrey_10);
      }
    }
    .bottom-row {
      display: flex;
      justify-content: space-between;
      padding: utils.in_rem(18px) utils.in_rem(32px);
      @include colors.background-color(interfaceSwGrey_5);
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { makeEscapeAction } from "@sourcewhale/shared/src/svelte/utils/escapable";
  import {
    editContactSections,
    editContactStore,
    showEditContact,
    todosModalItemStore,
  } from "../../stores";
  import BottomRow from "./BottomRow.svelte";
  import SalarySection from "./SalarySection.svelte";
  import Section from "./Section.svelte";
  import { confirmDirty } from "./stores";

  const { dirty } = editContactStore;

  const escape = makeEscapeAction(() => {
    if ($dirty) confirmDirty();
    else $showEditContact = false;
  });

  let isTodo = $derived($todosModalItemStore?.toDoId);
  let editContactSectionsFiltered = $derived(
    editContactSections.filter(
      (item) =>
        !item.restriction || item.restriction !== "hasCrm" || $userStore.hasCrm
    )
  );

  const snipMap = {
    default: defaultSection,
    salary: salarySection,
  };
</script>

{#snippet defaultSection(items, header)}
  <Section {items}>
    <div slot="header">{header}</div>
  </Section>
{/snippet}

{#snippet salarySection(items, header)}
  <SalarySection {items}>
    {header}
  </SalarySection>
{/snippet}

<div class="edit-contact" class:isTodo use:escape>
  {#if !isTodo}
    <!-- Place a header outside the body if it is not a todo -->
    <div class="header">
      <h2>Edit Contact Details</h2>
    </div>
  {/if}

  <div class="body" class:isTodo>
    {#if isTodo}
      <!-- Place the header within the body for todos -->
      <div class="header">
        <h2>Edit Contact Details</h2>
      </div>
      <div class="divider"></div>
    {/if}
    {#each editContactSectionsFiltered as section, index}
      {@const sectionSnippet = snipMap[section.kind]}
      {@render sectionSnippet(section.items, section.header)}
      {#if index < editContactSections.length - 1}
        <!-- Add a divider between sections -->
        <div class="divider"></div>
      {/if}
    {/each}
  </div>

  <div class="bottom-row">
    <BottomRow />
  </div>
</div>
